import { Injectable } from '@angular/core';
import { Vector3 } from 'babylonjs';

@Injectable({
  providedIn: 'root',
})
export class PolygonMathService {
  calculateLineLengths(positionsArr: Vector3[]): number[] {
    return positionsArr.map((_, i, arr) => {
      const next = (i + 1) % arr.length;
      return +Vector3.Distance(arr[i], arr[next]).toFixed(2);
    });
  }

  calculateLineCenters(positionsArr: Vector3[], yPosition: number): Vector3[] {
    return positionsArr.map((_, i, arr) => {
      const next = (i + 1) % arr.length;
      const center = Vector3.Center(arr[i], arr[next]);
      center.y = yPosition;
      return center;
    });
  }

  calculateCentroid(positions: Vector3[]): Vector3 {
    const mid = new Vector3(0, 0, 0);
    positions.forEach((pos) => {
      mid.x += pos.x;
      mid.y += pos.y;
      mid.z += pos.z;
    });
    mid.x /= positions.length;
    mid.y /= positions.length;
    mid.z /= positions.length;
    return mid;
  }
}
